import { TriageTableDrillDownConstants } from "./TriageDrillDownTable";
import { WorkflowConstants } from "./Workflow";

export const TriageCypressConstants = {
  TriageTableDrillDownConstants,
  WorkflowConstants
};
